import { useState } from 'react';

import { ActionButton, Field, TextInput } from '../../customer/account/account.ui';

import solicitationService from '../../../domain/services/solicitation/solicitation.service';
import communicationProvider from '../../../providers/communication.provider';

// Dia de hoje (ou da data salva) em BRT, no formato do <input type="date">.
export const isoDayOf = (value) => {
    const date = value ? new Date(value) : new Date();
    if (Number.isNaN(date.getTime())) return '';
    const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-CA', {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        })
            .formatToParts(date)
            .map((part) => [part.type, part.value])
    );
    return `${parts.year}-${parts.month}-${parts.day}`;
};

// Meio-dia em BRT: a data não muda de dia em nenhum fuso.
const protocoledAtOf = (isoDay) =>
    isoDay ? new Date(`${isoDay}T12:00:00-03:00`).toISOString() : null;

// Registro do protocolo feito pelo próprio cliente (campo "protocolado em"): só controle de prazos, nada vai ao tribunal.
export default function FilingManualForm({ request, verbs, setAlert, onSaved, onCancel }) {
    const [day, setDay] = useState(isoDayOf(request.protocoledAt));
    const [isSaving, setIsSaving] = useState(false);
    const hasRecord = !!request.protocoledAt;
    const mainId = request.mainId || request.id;

    const save = async (isoDay) => {
        setIsSaving(true);
        try {
            await solicitationService.editValue(mainId, { protocoledAt: protocoledAtOf(isoDay) });
            onSaved?.(isoDay ? 'Data registrada.' : 'Registro removido.');
        } catch (failure) {
            communicationProvider.getErrorMessage(failure, setAlert);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="flex flex-col gap-4" data-testid="filing-manual-form">
            <div>
                <p className="m-0 text-[15px] font-semibold text-[#1d1d1f]">{`Registrar ${verbs.noun} feito por você`}</p>
                <p className="m-0 mt-0.5 text-[13px] text-[#6b6b76]">
                    Fica só no seu controle de prazos. Nada é enviado ao tribunal.
                </p>
            </div>
            <div className="max-w-[260px]">
                <Field
                    label={`Data ${verbs.noun === 'distribuição' ? 'da distribuição' : 'do protocolo'}`}
                    htmlFor={`manual-filing-${mainId}`}
                >
                    <TextInput
                        id={`manual-filing-${mainId}`}
                        type="date"
                        value={day}
                        max={isoDayOf()}
                        onChange={(event) => setDay(event.target.value)}
                    />
                </Field>
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <ActionButton loading={isSaving} disabled={!day} onClick={() => save(day)}>
                    Salvar
                </ActionButton>
                <ActionButton variant="secondary" disabled={isSaving} onClick={onCancel}>
                    Cancelar
                </ActionButton>
                {hasRecord && (
                    <button
                        type="button"
                        className="ml-auto text-sm text-[#a23a2a] hover:underline disabled:opacity-50"
                        disabled={isSaving}
                        onClick={() => save(null)}
                    >
                        {`Não foi ${verbs.doneFem}`}
                    </button>
                )}
            </div>
        </div>
    );
}
